import { Button } from "@/components/ui/button";
import { useStepper } from "@/components/ui/stepper";
import { useTeams } from "@/contexts/teams-provider";
import { useTranslation } from "@/hooks/useTranslation";

export const SetupTrialEndedBillingIntroductionPage = () => {
  const { nextStep } = useStepper();
  const { t } = useTranslation();
  const { teamSelected } = useTeams();

  return (
    <div className="space-y-5 text-center">
      <h1 className="text-2xl font-bold text-primary">
        {t("setup.trialEndedBilling.introduction.title")}
      </h1>
      <p
        className="text-md"
        dangerouslySetInnerHTML={{
          __html: t("setup.trialEndedBilling.introduction.description", {
            teamName: teamSelected?.name || "",
          }),
        }}
      />
      <Button onClick={nextStep}>
        {t("setup.trialEndedBilling.introduction.button")}
      </Button>
    </div>
  );
};
